import Echo from 'laravel-echo';
 
import Pusher from 'pusher-js';
window.Pusher = Pusher;

// Use runtime configuration from window._avid_env instead of build-time process.env
const pusherConfig = window._avid_env || {};

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusherConfig.PUSHER_APP_KEY,
    cluster: pusherConfig.PUSHER_APP_CLUSTER,
    forceTLS: true
});